import { createActionCreator } from "deox";
import { IGciTrackerSettings } from "../../../types/types";

export const gciTrackerSettingsLoading = createActionCreator(
  "gciTrackerSettings/loading",
);

export const gciTrackerSettingsLoadingError = createActionCreator(
  "gciTrackerSettings/loadingError",
  (resolve) => (error: string) => resolve(error),
);

export const gciTrackerSettingsLoaded = createActionCreator(
  "gciTrackerSettings/loaded",
  (resolve) => (payload: IGciTrackerSettings) => resolve(payload),
);

export const gciTrackerSettingsUpdating = createActionCreator(
  "gciTrackerSettings/updating",
);

export const gciTrackerSettingsUpdatingError = createActionCreator(
  "gciTrackerSettings/updatingError",
  (resolve) => (error: string) => resolve(error),
);

export const gciTrackerSettingsUpdated = createActionCreator(
  "gciTrackerSettings/updated",
  (resolve) => (payload: IGciTrackerSettings) => resolve(payload),
);

export const clearGciTrackerError = createActionCreator(
  "gciTrackerSettings/clearError",
);
